/** Full-page navigation that replaces the current history entry (mockable in tests). */
export function replaceLocation(url: string) {
  window.location.replace(url);
}
